const CHAT_BASE_URL = 'https://apisp.jyb.com.tw/'

const state = {}

const getters = {}

const mutations = {}

const actions = {
  searchChat ({ rootState }, params) {
    return rootState.axios.get('/magicbuy/chat/search-chat', {
      params,
      baseURL: CHAT_BASE_URL,
    })
  },
  sendChat ({ rootState }, params) {
    return rootState.axios.post('/magicbuy/chat/send-chat', params, {
      baseURL: CHAT_BASE_URL,
      timeRetry: false,
    })
  },
  readChat ({ rootState }, params) {
    return rootState.axios.post('/magicbuy/chat/read-chat', params, {
      baseURL: CHAT_BASE_URL,
    })
  },
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
}
